import { API_URL } from "../config/apiConfig";
import { listingCategoryLabel } from "../data/listingCategories";

export function mediaUrl(path) {
  if (!path) return "";
  if (/^(https?:|blob:)/.test(path)) return path;
  return `${API_URL.replace(/\/$/, "")}${path}`;
}

export function toListingCard(
  listing,
  { currentUserId, favoriteIds = new Set(), hasMatchScore = false, seller = {} } = {}
) {
  const ownerId = seller.id || listing.owner_id;
  return {
    id: listing.id,
    title: listing.title,
    category: listingCategoryLabel(listing.category),
    categoryKey: listing.category,
    shopCategory: listing.shop_category || null,
    location: listing.location || seller.location || "",
    price: listing.price || `${listing.price_amount} ${listing.price_currency}`,
    priceAmount: listing.price_amount,
    image: mediaUrl(listing.primary_image_url),
    images: (listing.image_urls || [listing.primary_image_url]).filter(Boolean).map(mediaUrl),
    description: listing.description || "",
    condition: listing.condition || null,
    status: listing.status || "active",
    inventoryCount: listing.inventory_count,
    score: hasMatchScore ? matchConfidence(listing.match_score) : null,
    hasMatchScore,
    aiScore: listing.ai_score ?? null,
    ownerId,
    seller:
      seller.shop_name ||
      listing.seller_shop_name ||
      seller.display_name ||
      listing.seller_display_name ||
      listing.seller ||
      "Ukendt sælger",
    sellerRole: seller.role || listing.seller_role || "user",
    sellerLogo: mediaUrl(seller.shop_logo_url || listing.seller_shop_logo_url),
    ratingAverage: seller.rating_average ?? listing.seller_rating_average ?? listing.ratingAverage ?? 0,
    ratingCount: seller.rating_count ?? listing.seller_rating_count ?? listing.ratingCount ?? 0,
    completedSalesCount: seller.completed_sales_count ?? listing.completed_sales_count ?? 0,
    verified: seller.seller_verified ?? listing.seller_verified ?? listing.verified ?? false,
    isFavorite: favoriteIds.has(listing.id),
    isOwner: ownerId === currentUserId,
  };
}

export function matchConfidence(rawScore) {
  if (!Number.isFinite(rawScore)) return null;
  // Unrelated CLIP marketplace images commonly sit near 0.75 cosine similarity.
  return Math.round(Math.max(0, Math.min(1, (rawScore - 0.75) / 0.25)) * 100);
}
